import { render, staticRenderFns } from "./MidAutumnBanner.vue?vue&type=template&id=280bb293&scoped=true"
import script from "./MidAutumnBanner.vue?vue&type=script&lang=js"
export * from "./MidAutumnBanner.vue?vue&type=script&lang=js"
import style0 from "./MidAutumnBanner.vue?vue&type=style&index=0&id=280bb293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280bb293",
  null
  
)

export default component.exports